import * as React from 'react';
import { Button, DatePicker } from '@symphony-ui/uitoolkit-components';
import RenderingContext from 'contexts/RenderingContext';
import Maturity from '../../../../models/data/Maturity';
const MaturityCellDatePicker = ({ hasOverride, hasValue, isDisabled, onChange, save, value, }) => {
    const { datePattern } = React.useContext(RenderingContext);
    const date = React.useMemo(() => value?.date !== undefined ? new Date(value.date.year ?? 0, (value.date.monthValue ?? 1) - 1, value.date.dayOfMonth ?? 1) : undefined, [value?.date]);
    const maturityRef = React.useRef(null);
    const stopMouseDown = React.useCallback((e) => e.stopPropagation(), []);
    React.useEffect(() => {
        const currentRef = maturityRef.current;
        if (currentRef !== null) {
            currentRef.addEventListener('mousedown', stopMouseDown, { capture: true });
            return () => {
                currentRef.removeEventListener('mousedown', stopMouseDown);
            };
        }
    }, [stopMouseDown]);
    const onClickPerpetual = React.useCallback(() => {
        (async () => save(new Maturity({ perpetual: true })))();
    }, [save]);
    const onClickTbc = React.useCallback(() => {
        (async () => save(new Maturity({})))();
    }, [save]);
    const onClickRemove = React.useCallback(() => {
        (async () => save(undefined))();
    }, [save]);
    return (React.createElement("div", { ref: maturityRef },
        React.createElement(DatePicker, { autoFocus: true, date: date, disabled: isDisabled, format: datePattern('YMD'), todayButton: "TODAY", onChange: onChange, showRequired: true, showOverlay: true }),
        React.createElement("div", { style: { display: 'flex', marginLeft: '10px', justifyContent: 'center' } },
            React.createElement(Button, { disabled: isDisabled, onClick: onClickPerpetual, variant: "tertiary-accent" }, "PERPETUAL"),
            hasValue
                ? React.createElement("div", null,
                    React.createElement(Button, { disabled: isDisabled, onClick: onClickTbc, variant: "tertiary-accent" }, "TBC")) : undefined,
            hasOverride
                ? React.createElement("div", null,
                    React.createElement(Button, { disabled: isDisabled, onClick: onClickRemove, variant: "tertiary-destructive" }, "REMOVE")) : undefined)));
};
export default MaturityCellDatePicker;
